// extracted by mini-css-extract-plugin
export default {"stepsContainer":"Steps_stepsContainer__UrPed","step":"Steps_step__CS4dn","stepNumber":"Steps_stepNumber__m2eLD","stepNumberDisabled":"Steps_stepNumberDisabled__BAGbm"};